import React, {An} from "react";

const contactPhrases = [
  "We are here for you",
  "We are here to help you"
]
export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
        <a href="#page-top">
          <img
              src={"../img/picsla-logo-mini.webp"}
            />
          </a>{" "}
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            
            <span className="sr-only">Toggle navigation</span>{" "} {/* Toto je úmyslně pro sr */}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
         
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                {props.data ? props.data.functions : "Loading..."}
              </a>
            </li>
            <li>
              <a href="#pricing" className="page-scroll">
              {props.data ? props.data.pricing : "Loading..."}
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
              {props.data ? props.data.about : "Loading..."}
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
              {props.data ? props.data.gallery : "Loading..."}
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
              {props.data ? props.data.testimonials : "Loading..."}
              </a>
            </li> */}
            <li>
              <a href="#team" className="page-scroll">
              {props.data ? props.data.team : "Loading..."}
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
              {props.data ? props.data.contact : "Loading..."}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
